import { Warning } from '@mui/icons-material';
import {
  Box,
  Button as MuiButton,
  Card as MuiCard,
  CardContent as MuiCardContent,
  Grid,
  styled,
  Typography,
} from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers';

export const TimeRowGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FlexBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const TooltipWrapper = styled(Box)`
  margin-left: 10px;
`;

export const LinkContainer = styled(MuiButton)`
  padding: 0;
  justify-content: flex-start;
  text-align: left;
  min-width: unset;
  max-width: 200px;
  & > a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
    color: inherit;
  }
`;

export const Card = styled(MuiCard)(
  ({ theme, $hasDayActive, $hasOverride }) => `
      width: 155px;
      height: fit-content;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-radius: 8px;
      cursor: pointer;
      padding: ${$hasDayActive ? '0px 0px 5px 0px' : '0px'};
      text-align: start;
      background-color: ${theme.palette.primary?.lightest};
      margin-bottom: 30px;
      border: 2px solid ${
        $hasDayActive
          ? `${theme.palette.brand?.lightBlue}`
          : `${theme.palette.brand?.disabled}`
      };
      & .MuiTextField-root {
        background: ${$hasOverride && `${theme.palette.brand?.lightBlue} `}
      }
      &:hover {
        cursor: pointer;
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
        border: 2px solid ${
          $hasDayActive
            ? theme.palette.brand?.blue
            : theme.palette.brand?.disabled
        };
        & .MuiTextField-root {
          background: ${
            $hasDayActive
              ? `${theme.palette.brand?.lightBlue} `
              : `${theme.palette.brand?.disabled}`
          }
        }
      }
    `,
);

export const AssemblyCard = styled(Card)(
  ({ theme }) => `
      width: 100%;
      display: flex;
      border-radius: 8px;
      text-align: start;
      border: 2px solid ${`${theme.palette.brand?.disabled}`};
      margin-bottom: 30px
    `,
);

export const CardHeader = styled(Grid)(
  ({ theme, $hasDayActive }) => `
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: space-between;
  padding: 0 3px 0 10px;
  background-color: ${
    $hasDayActive
      ? theme.palette.brand?.lightBlue
      : theme.palette.brand?.lightGrey
  };
      `,
);

export const CardHeaderContent = styled(CardHeader)`
  width: 100%;
  max-width: 305px;
`;

export const CardContent = styled(MuiCardContent)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
`;

export const StartTimeContainer = styled(Grid)`
  padding: 10px;
`;

export const LabelText = styled(Typography)(
  ({ theme }) => `
  color:${theme.palette.brand?.charcoal};
  margin-bottom: 8px;
  `,
);

export const StyledMobileTimePicker = styled(MobileTimePicker)(
  ({ theme, disabled, isOverride }) => `
  & input {
    padding: 8px;
  }
  background-color: ${
    disabled
      ? `${theme.palette.brand?.disabled}`
      : isOverride
      ? `${theme.palette.brand?.lightBlue}`
      : 'inherit'
  };
`,
);

export const WarningIconContainer = styled(Box)`
  text-align: center;
  margin-top: 10px;
`;

export const StyledWarningIcon = styled(Warning)(
  ({ theme }) => `
  color:${theme.palette.brand?.warning};
`,
);

export const Button = styled(MuiButton)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;
